import React from 'react';
import { Button } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

const ShareButton = ({ secretLink }) => {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'View my secret',
          text: 'Here is a secret shared with you:',
          url: secretLink,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      alert('Sharing not supported on this browser. Please copy the link manually.');
    }
  };

  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<ShareIcon />}
      onClick={handleShare}
    >
      Share Secret
    </Button>
  );
};

export default ShareButton;
